import React from 'react';

import type { TabItem } from 'src/components/common';
import { Tabs } from 'src/components/common';
import { TableDataProvider } from 'src/providers/TableDataProvider';

import { EmployersBillingTable } from './EmployersBillingTable';
import { PaymentHistoryTable } from './PaymentHistoryTable';
import { containerStyles } from './styles';
import { VerifiersBillingTable } from './VerifiersBillingTable';

export const GeneralBillingTabs: React.FC = () => {
  return <Tabs tabs={billingTabs} containerProps={{ sx: containerStyles }} />;
};

const billingTabs: TabItem[] = [
  {
    key: 'Verifier Billing Rules',
    label: 'Verifier Billing Rules',
    component: (
      <TableDataProvider>
        <VerifiersBillingTable />
      </TableDataProvider>
    ),
  },
  {
    key: 'Employer Billing Rules',
    label: 'Employer Billing Rules',
    component: (
      <TableDataProvider>
        <EmployersBillingTable />
      </TableDataProvider>
    ),
  },
  {
    key: 'Revenue History',
    label: 'Revenue History',
    component: <PaymentHistoryTable showVerifier showRefundAction />,
  },
];
